import { useProductFilters, useFacets } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import { isVisualFilter } from "../helpers"

import Facet from "./Facet"
import RangeFacet from "./RangeFacet"


export default function ToolbarFilters() {
    const { facets } = useFacets()
    const { filters, removeAll } = useProductFilters()
    const [ activeDropdown, setActiveDropdown ] = useState(null);

    const handleDropdownChange = (facetId) => {
        setActiveDropdown(activeDropdown === facetId ? null : facetId);
    }

    useEffect(() => {
        const handleClick = (e) => {
            if(!e.target.closest('.ns-facet') && e.target.id !== "ns-sort") {
                setActiveDropdown(null);
            }
        }

        if(activeDropdown) {
            window.addEventListener('click', handleClick);
            return () => window.removeEventListener('click', handleClick);
        }
    }, [ activeDropdown ])

    return (
        <div class="ns-toolbar-filters ns-hidden ns-lg-flex ns-items-center">
            <ul class="ns-flex ns-flex-nowrap ns-items-center">
                {facets?.map(facet => {
                    if(isVisualFilter(facet.name)) return null;
                    switch (facet.type) {
                        case "terms":
                            return <Facet 
                                    key={facet.id} 
                                    facet={facet}
                                    activeDropdown={activeDropdown}
                                    handleDropdownChange={handleDropdownChange}
                                />
                        case "stats":
                            return <RangeFacet 
                                    key={facet.id} 
                                    facet={facet}
                                />
                        default:
                            return null
                    }
                })}
            </ul>

            {filters?.length > 0 && ( 
                <button
                    type="button"
                    class="ns-clearall ns-folio-reg"
                    onClick={removeAll}
                >
                    Clear All
                </button>
            )}
        </div>
    )
}
